"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    id: "loginRegisterModalHeadlineId",
    tabindex: "-1",
    class: "m-0 mb-6 text-[2rem] font-semibold leading-[2.7142857rem]"
};
const store_1 = require("@/state/store");
const detectingMobile_1 = __importDefault(require("@/services/detectingMobile"));
const main_1 = require("@/main");
exports.default = (0, vue_1.defineComponent)({
    __name: 'HeadlineModalDesktop',
    setup(__props) {
        const { isMobile } = (0, detectingMobile_1.default)();
        return (_ctx, _cache) => {
            return (!(0, vue_2.unref)(isMobile) && !(0, vue_2.unref)(store_1.store).isLandingPage)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("h2", _hoisted_1, (0, vue_2.toDisplayString)((0, vue_2.unref)(main_1.$t)((0, vue_2.unref)(store_1.store).isLogin ? "login.headline" : "registration.headline")), 1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
